// api.ts — Point d'entrée historique du client API.
//
// S6 (mai 2026) : api.ts est devenu un simple re-export depuis api/index.ts
// suite au découpage en 1 fichier par ressource (api/auth.ts, api/projects.ts,
// api/revisions.ts, …). Ce shim conserve :
//   - le `import './api.js'` côté main.ts (ordre de chargement inchangé) ;
//   - le `window.api` pour les ~30 modules qui consomment l'API en bare ref ;
//   - les exports nommés `api` / `ApiClient` pour les futurs imports ESM.
//
// À retirer en S7 quand tous les modules feront `import { api } from './api/index.js'`.

import { api } from '@/api/index.js';
export type { ActionMutationOptions, ApiClient, HttpMethod } from '@/api/index.js';
export { api };

// Shim window.api pour rétrocompat avec les modules qui utilisent `api.X()`
// en bare ref (résolu via le global `var api: Window['api']` dans
// core-globals.d.ts).
window.api = api;
